<!-- 加载中 -->
<template>
  <div
    v-show="show"
    class="loading_wrap"
  >
    <van-loading
      class="loading_spinner"
      type="spinner"
      :color="color"
      vertical
    >{{text}}</van-loading>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Loading'
    },
    color: {
      type: String,
      default: '#069'
    }
  },
  data() {
    return {

    };
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.loading_wrap {
  // display: none;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 15;
  background: #fff;
  .loading_spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
</style>